module.exports = __webpack_public_path__ + "img/wide.92cc44e7.jpg";